import { VenueAnalysisSelection } from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';

export interface VenueAnalysisVisibleBreakdowns {
    marketHistorical: boolean;
    marketToday: boolean;
    orderVenue: boolean;
}

export const initialVenueAnalysisVisibleBreakdowns = {
    marketHistorical: false,
    marketToday: false,
    orderVenue: true,
};

export interface VenueAnalysisComponentState {
    visibleBreakdowns: VenueAnalysisVisibleBreakdowns;
    selection?: VenueAnalysisSelection;
}

export const initialVenueAnalysisComponentState: VenueAnalysisComponentState = {
    visibleBreakdowns: initialVenueAnalysisVisibleBreakdowns,
};

export function toggleVenueAnalysisComponentProperty<
    T extends keyof VenueAnalysisComponentState,
>(
    venueAnalysisComponentState: VenueAnalysisComponentState,
    section: T,
    property: keyof VenueAnalysisComponentState[T]
) {
    return {
        ...venueAnalysisComponentState,
        [section]: {
            ...venueAnalysisComponentState[section],
            [property]: !venueAnalysisComponentState[section]![property],
        },
    };
}
